export default invoiceDetails

/** @ngInject */
function invoiceDetails() {
    return ({
        restrict: 'E',
        scope: {
            invoices: '=',
        },
        template: require('./invoiceDetails.jade')(),
    })
}



// WEBPACK FOOTER //
// ./src/states/invoice/component/invoiceDetails.js